import {
    Component,
    Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    ConfigurationEntryValueType,
    ICredentialStoreConfigurationEntry,
} from '@models';

@Component({
    selector: 'ui-generic-form-entry',
    templateUrl: './generic-form-entry.component.html',
})
export class GenericFormEntryComponent {
    public ValueTypes = ConfigurationEntryValueType;

    @Input() dynamicFormEntry!: ICredentialStoreConfigurationEntry;
    @Input() form!: FormGroup;
}
